var lastScrollTop = 0;
//resize sizes
let w = window,
	d = document,
	e = d.documentElement,
	g = d.getElementsByTagName('body')[0],
	windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
	windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;




(function () {

	document.addEventListener("DOMContentLoaded", function (event) {
		window.onload = onLoad();
	});

	// Remove empty <p> tags created by tinymce
	const paragraph = document.querySelectorAll('p') || [];
	paragraph.forEach(e => (e.innerHTML.trim() === '') && e.parentNode.removeChild(e));

	// slick default setting
	let defaultsettings = { loop: true, speed: 700, effect: 'slide', navigation: { nextEl: '.swiper-prev', prevEl: '.swiper-next' } };

	// start slider default
	document.querySelectorAll('.swiper-js').forEach((element, i) => {

		let swiperConfig = element.dataset.swiper ? JSON.parse(element.dataset.swiper) : defaultsettings;

		element.setAttribute(`data-swiper-${i}`, "")

		let swiper = new Swiper(`[data-swiper-${i}]`, swiperConfig);

		// Custom dots funcionlity
		if (swiper.passedParams.customcount) {
			let all_values = [];
			const class_bullet = "bullet";
			const data_dots = `[data-dots]`;
			document.querySelectorAll(`${data_dots}`).forEach((element, i) => {
				let value_dot = element.dataset.dots;
				all_values.push(`<span class="${class_bullet} animate-fade top" data-goto="${i}">${value_dot}</span>`);
			})
			document.querySelector(`${swiper.passedParams.customcount}`).innerHTML = all_values.join("")
			document.querySelector(`.${class_bullet}`).classList.add('active');
			document.querySelectorAll("[data-goto]").forEach((element, index) => {
				element.addEventListener("click", () => {
					document.querySelectorAll(`.${class_bullet}`).forEach(item => {
						item.classList.remove('active');
					});
					element.classList.add('active');
					swiper.slideTo(index)
				})
			});
			swiper.on('slideChange', () => {
				document.querySelectorAll(`.${class_bullet}`).forEach(item => {
					item.classList.remove('active');
				});
				document.querySelectorAll(`.${class_bullet}`)[swiper.realIndex].classList.add('active')
				//console.log(swiper.realIndex);
			});
		}

	});

	document.querySelectorAll('[data-swiper-control]').forEach((mainSlider) => {
		const selectorsLinked = mainSlider.dataset.swiperControl ? JSON.parse(mainSlider.dataset.swiperControl) : [];
		if (selectorsLinked.length < 1) {
			return false;
		}

		const slidersLinked = selectorsLinked
			.map((selector) => {
				return [...document.querySelectorAll(selector)].map((el) => el.swiper);
			})
			.flat();
		mainSlider.swiper.controller.control = slidersLinked;
	});

	let CloseMenu = document.querySelectorAll('.close-menu');

	if (CloseMenu[0]) {
		CloseMenu[0].addEventListener('click', function (e) {
			document.getElementById('navContainer').classList.remove('open');
			document.getElementById('mobileBurger').classList.remove('open');
		});
	}

	if (document.getElementById('mobileBurger')) {

		document.getElementById('mobileBurger').addEventListener('click', function () {
			document.getElementById('navContainer').classList.toggle('open')
			this.classList.toggle('open');
		})

	}

	// Main Nav Dropdown ----------------------------------------------------------------
	const navItems = document.querySelectorAll('#primary-nav li');
	if (navItems) {
		navItems.forEach(function (item) {
			item.addEventListener('mouseover', function () {
				item.classList.add('hover');
				let submenu = item.querySelector('ul.submenu');
				if (submenu) {
					submenu.classList.add('open');
				}
			});

			item.addEventListener('mouseout', function () {
				item.classList.remove('hover');
				let submenu = item.querySelector('ul.submenu');
				if (submenu) {
					submenu.classList.remove('open');
				}
			});
		});
	}

	// fancybox

	$('[data-fancybox]').fancybox({
		loop: true,
		backFocus: false,
		autoFocus: false,
	});

	let aHref = document.querySelectorAll("a[href^='#']:not(:where(a[data-fancybox], a[data-filter], a.accordion-toggle, a#js_btn_book, a.ui-state-default))");
	if (aHref) {
		aHref.forEach(function (a_href) {
			a_href.addEventListener('click', function (e) {
				e.preventDefault();
				let strAnchor = this.hash.slice(1);
				animateto(strAnchor);
			});
		});
	}

	//// Forms animation for labels
	//email signup animation
	if (document.getElementById('email-signup_email_address')) {
		document.getElementById('email-signup_email_address').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_FNAME')) {
		document.getElementById('email-signup_FNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	if (document.getElementById('email-signup_LNAME')) {
		document.getElementById('email-signup_LNAME').addEventListener('focus', function () {
			this.parentElement.classList.add('moved');
		});
	}
	//CMS forms label animation
	if (document.getElementsByClassName('form-module__field').length > 0) {
		const MODULE_FIELDS = document.querySelectorAll('.form-module__field');
		MODULE_FIELDS.forEach((field) => {
			if (field.getElementsByTagName('input').length > 0) {
				if (field.getElementsByTagName('input')[0].type.toLowerCase() != 'checkbox' && field.getElementsByTagName('input')[0].type.toLowerCase() != 'radio') {
					field.getElementsByTagName('input')[0].addEventListener('focus', function () {
						this.parentElement.classList.add('moved');
					});
				}
			}
			if (field.getElementsByTagName('select').length > 0) {
				field.getElementsByTagName('select')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
			if (field.getElementsByTagName('textarea').length > 0) {
				field.getElementsByTagName('textarea')[0].addEventListener('focus', function () {
					this.parentElement.classList.add('moved');
				});
			}
		});
	}

	// Open Table Widget Show/Hide
	$('#toggle-widget').click(function () {
		$(this).toggleClass("open");
		$(".open-table-block").toggleClass("open");
	});

	// Open Options Languages

	$('.select--lang').click(function (e) {
		e.preventDefault();
		$('.header__lang-options').toggleClass('open');
	});

	/* Lightbox Gallerys */
	const customLightbox = new LBX('.js-lbx-gallery', {
		customClass: 'lbx-gallery',
	});


	 /* vanilla JS fancybox */
	 if(document.getElementsByClassName('lightbox').length > 0){
		let allLightboxes = document.getElementsByClassName('js-lightboxbtn');
		let allLightboxesLength = allLightboxes.length;

		for(let j = 0; j < allLightboxesLength; j++ ){
			allLightboxes[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.getAttribute('href').split('#')[1];
				document.getElementById(currentTarget).classList.add('open');
				document.body.classList.add('no-scroll');
			});

		}

		let allLightcloses = document.getElementsByClassName('js-lightboxclose');
		let allLightclosesLength = allLightcloses.length;

		for(let j = 0; j < allLightclosesLength; j++ ){
			allLightcloses[j].addEventListener('click', function(e){
				e.preventDefault();
				let currentTarget = this.parentElement.parentElement.id;
				document.getElementById(currentTarget).classList.remove('open');
				document.body.classList.remove('no-scroll');
			});
		}

		let allCloseTerms = document.getElementsByClassName('js-close-terms');
		let allTermsLight = document.querySelectorAll('.terms-lbx');
		for(let j = 0; j < allCloseTerms.length; j++ ){
			allCloseTerms[j].addEventListener('click', function(e){
				e.preventDefault();
				allTermsLight.forEach(el => el.classList.remove('open'));
			});
		};

		let allLbxWraps = document.querySelectorAll('.lightbox');

		for(const lbxWrap of allLbxWraps) {
			lbxWrap.addEventListener('click', (e) => {
				const innerWrap = lbxWrap.querySelector('.lightbox-wrap') ;
				if(!innerWrap.contains(e.target)) {
					allLbxWraps.forEach(el => el.classList.remove('open'));
					document.body.classList.remove('no-scroll');
				}
			})
		}

	};





	if (document.getElementById('navImages')) {

		let allMainLinks = document.getElementById('primary-nav').querySelectorAll('li')
		let allMainImages = document.getElementById('navImages').querySelectorAll('figure')

		allMainLinks.forEach((link, index) => {

			link.addEventListener('mouseenter', function () {
				if (allMainImages[index] !== undefined) {
					allMainImages[index].classList.add('active')
				}
			})
			link.addEventListener('mouseleave', function () {
				if (allMainImages[index] !== undefined) {
					allMainImages[index].classList.remove('active')
				}
			})

			let linkA = link.querySelectorAll('a')[0];
			if (linkA.classList.contains('active')) {
				if (allMainImages[index] !== undefined) {
					allMainImages[index].classList.add('active')
				}
			}

		});

	}


}());

function scrollW() {
	//check scroll down or up for header styles
	let st = window.pageYOffset || document.documentElement.scrollTop;
	let header = document.getElementById('header');
	if (st > 80) {
		if (st > lastScrollTop) {
			// downscroll code
			if (!header.classList.contains('down')) {
				header.classList.add('down');
				header.classList.remove('up');
			}
		} else {
			// upscroll code
			if (!header.classList.contains('up')) {
				header.classList.add('up');
				header.classList.remove('down');
			}
		}
	} else {
		if (header.classList.contains('up') || header.classList.contains('down')) {
			header.classList.remove('up');
			header.classList.remove('down');
		}
	}
	lastScrollTop = st <= 0 ? 0 : st; // For Mobile or negative scrolling
}



function onLoad() {
	w = window,
		d = document,
		e = d.documentElement,
		g = d.getElementsByTagName('body')[0],
		windowWidth = w.innerWidth || e.clientWidth || g.clientWidth,
		windowHeight = w.innerHeight || e.clientHeight || g.clientHeight;

	convertBtn();

	//Check anchor on URL
	let anchorHref = window.location.href;
	if (anchorHref.indexOf('#') > 0) {
		if (anchorHref.split('#').length === 2) {
			let windowTarget = anchorHref.split('#')[1];
			if (document.getElementById(windowTarget)) {
				setTimeout(() => {
					animateTo(windowTarget);
				}, 600);
			}
		}
	}

	window.addEventListener('scroll', function () {
		scrollW();
	})

}


function convertBtn() {
	setTimeout(() => {
		if (document.getElementsByClassName('btn').length > 0) {
			let ALL_BTNS = document.querySelectorAll('.btn');
			ALL_BTNS.forEach((btn) => {
				if (btn.getAttribute('type') !== 'submit') {
					let INNER_TEXT = btn.innerHTML;
					btn.innerHTML = '<span>' + INNER_TEXT + '</span>';
				}
			});
		}
	}, "1000");
}



//vanilla js scroll TO animation
function animateTo(target) {
	var gotoTarget = offset(document.getElementById(target)).top - 250;
	var from = window.pageYOffset;
	var to = gotoTarget;
	var duration = 1300;
	var start = new Date().getTime();

	//time interval
	var timer = setInterval(function () {
		var time = new Date().getTime() - start;

		if (from <= to) {
			var y = easeInOutQuart(time, from, to - from, duration);
		} else {
			var y = easeInOutQuart(time, from, -(from - to), duration);
		}
		window.scrollTo(0, y);
		if (time >= duration) clearInterval(timer);
	}, 1000 / 60);

	window.scrollTo(0, from);
}
//ease movement
function easeInOutQuart(t, b, c, d) {
	if ((t /= d / 2) < 1) return (c / 2) * t * t * t * t + b;
	return (-c / 2) * ((t -= 2) * t * t * t - 2) + b;
}
function offset(el) {
	var rect = el.getBoundingClientRect(),
		scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
		scrollTop = window.pageYOffset || document.documentElement.scrollTop;
	return { top: rect.top + scrollTop, left: rect.left + scrollLeft };
}
